export default __webpack_public_path__ + "static/media/linkedin.5f00672d.svg";